// ChangeHomeworkTypeModal.jsx - Reclassify a pending submission to a different
// homework type (e.g. student uploaded their TH2 answer under the TH1 slot).
// Only offered for unclaimed submissions - see changeSubmissionHomeworkType.
import React, { useState, useEffect } from 'react';

function ChangeHomeworkTypeModal({
  submission,
  homeworkNames,
  onClose,
  onConfirm
}) {
  const [selectedType, setSelectedType] = useState('');

  useEffect(() => {
    setSelectedType('');
  }, [submission]);

  if (!submission) return null;

  const options = Object.keys(homeworkNames || {}).filter(type => type !== submission.homeworkType);

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 999
        }}
      />

      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000,
        minWidth: '480px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', color: '#2c3e50' }}>
          Change Homework Type
        </h3>
        <p style={{ color: '#7f8c8d', marginBottom: '16px' }}>
          {submission.studentName}'s uploaded file stays exactly as-is - only what type it's
          filed under changes. Currently: <strong>{homeworkNames?.[submission.homeworkType] || submission.homeworkType}</strong>.
          The student is not notified.
        </p>

        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
          Correct type *
        </label>
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            border: '2px solid #e2e8f0',
            borderRadius: '6px',
            fontSize: '14px',
            marginBottom: '24px'
          }}
        >
          <option value="">Select the correct homework type...</option>
          {options.map(type => (
            <option key={type} value={type}>{homeworkNames?.[type] || type}</option>
          ))}
        </select>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              background: '#ecf0f1',
              color: '#2c3e50',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Cancel
          </button>

          <button
            disabled={!selectedType}
            onClick={() => onConfirm(submission.id, selectedType)}
            style={{
              padding: '12px 24px',
              background: selectedType ? '#c33329' : '#f0b3af',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: selectedType ? 'pointer' : 'not-allowed',
              fontWeight: '600'
            }}
          >
            Change Type
          </button>
        </div>
      </div>
    </>
  );
}

export default ChangeHomeworkTypeModal;
